import { html } from 'htm/preact';
import { MapGeoDoc } from '../lib/mapGeo';

/**
 * Legenda sobreposta ao mapa, no canto inferior esquerdo.
 *
 * Escalonada e com quebras desiguais — a decisão visual mais consequente da peça.
 * Uma escala linear em 0-100% faria os 92%-99,9% de Portugal parecer uma chapada
 * uniforme de cor; as quebras (ver THRESHOLDS no gerador) apertam onde a variação
 * editorialmente interessa. A totalidade tem swatch próprio, nunca confundível com
 * a banda mais alta de parcial (99,5%).
 *
 * As cores vêm das mesmas custom properties que o mapa lê em lib/palette.ts — é o
 * SCSS a fonte única, não uma lista duplicada aqui.
 */
export function MapLegend({ geo }: { geo: MapGeoDoc }) {
    return html`
        <div class="eclipse-legend">
            <p class="eclipse-legend__title">Ocultação do Sol no máximo</p>
            <ul class="eclipse-legend__list">
                ${geo.bands.features.map(
                    (f, i) => html`
                        <li key=${f.properties.threshold} class="eclipse-legend__item">
                            <span class="eclipse-legend__swatch" style=${`background:var(--eclipse-band-${i})`}></span>
                            <span class="eclipse-legend__value">${f.properties.label}</span>
                        </li>
                    `,
                )}
                ${geo.totality.features.length > 0 &&
                html`
                    <li class="eclipse-legend__item eclipse-legend__item--totality">
                        <span class="eclipse-legend__swatch eclipse-legend__swatch--totality"></span>
                        <span class="eclipse-legend__value">Totalidade</span>
                    </li>
                `}
            </ul>
            ${geo.visibilityLimit.features.length > 0 &&
            html`
                <p class="eclipse-legend__note">
                    <span class="eclipse-legend__line eclipse-legend__line--visibility"></span>
                    <span>Limite de visibilidade do eclipse (pôr-do-sol)</span>
                </p>
            `}
        </div>
    `;
}
